import { Box, Tooltip, Typography } from '@mui/material';
import { FC } from 'react';

interface DashboardTooltipProps {
  dashboards: string[];
  totalDashboards: number;
}

const tooltipListContent = (dashboards: string[]) => (
  <Box component="ul" sx={{ margin: 0, paddingLeft: '0.5rem' }}>
    {dashboards.map((dashboard) => (
      <Typography
        key={dashboard}
        component="li"
        sx={{ fontSize: '0.75rem', fontWeight: 500, color: '#F6F8F9' }}
      >
        {dashboard}
      </Typography>
    ))}
  </Box>
);

const DashboardTooltip: FC<DashboardTooltipProps> = ({ dashboards, totalDashboards }) => {
  const isAll = dashboards.length === totalDashboards;

  if (isAll) {
    return (
      <Typography sx={{ fontSize: '0.875rem', fontWeight: 500, color: '#162936' }}>All</Typography>
    );
  }

  if (dashboards.length === 0) {
    return (
      <Typography sx={{ fontSize: '0.875rem', fontWeight: 500, color: '#162936' }}>
        {`${dashboards.length}/${totalDashboards}`}
      </Typography>
    );
  }

  return (
    <Tooltip
      title={tooltipListContent(dashboards)}
      placement="bottom-start"
      slotProps={{
        tooltip: {
          sx: {
            bgcolor: '#162C36',
            borderRadius: '0.5rem',
            padding: '0.75rem 1rem',
            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.15)',
            maxWidth: '280px',
            margin: '0 !important',
          },
        },
      }}
    >
      <Typography
        component="span"
        sx={{
          fontSize: '0.875rem',
          fontWeight: 500,
          color: '#162936',
          cursor: 'pointer',
          display: 'inline-block',
          '&:hover': {
            textDecoration: 'underline',
            textDecorationStyle: 'dotted',
            textUnderlineOffset: '2px',
          },
        }}
      >
        {`${dashboards.length}/${totalDashboards}`}
      </Typography>
    </Tooltip>
  );
};

export default DashboardTooltip;
